import { render } from "./OTPResend.vue?vue&type=template&id=380a1ac0&scoped=true&ts=true"
import script from "./OTPResend.vue?vue&type=script&lang=ts"
export * from "./OTPResend.vue?vue&type=script&lang=ts"

import "./OTPResend.vue?vue&type=style&index=0&id=380a1ac0&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380a1ac0"]])

export default __exports__